import { useNavigate } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Product as V } from '../components/DashboardLayout';
import TrustTradeLogo from '../components/TrustTradeLogo';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: V.bg,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: V.sans,
      padding: '24px',
      textAlign: 'center',
    }}>
      <div style={{ marginBottom: 40 }}>
        <TrustTradeLogo dark size="medium" showText />
      </div>

      {/* Icon */}
      <div
        style={{
          width: 72, height: 72,
          borderRadius: '50%',
          background: V.hover,
          border: `1px solid ${V.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 28,
        }}
      >
        <FileQuestion size={32} color={V.sub} strokeWidth={1.5} />
      </div>

      <p style={{
        fontSize: 12, fontWeight: 700,
        color: V.accent,
        letterSpacing: '0.15em',
        margin: '0 0 10px',
      }}>
        404
      </p>

      <h1 style={{
        fontSize: 26, fontWeight: 800,
        color: V.text,
        margin: '0 0 12px',
        letterSpacing: '-0.02em',
      }}>
        Page not found
      </h1>

      <p style={{
        fontSize: 14, color: V.sub,
        maxWidth: 320, lineHeight: 1.6,
        margin: '0 0 32px',
      }}>
        The page you're looking for doesn't exist or has been moved.
        Double-check the URL or return to safety.
      </p>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '10px 24px', borderRadius: 10,
            border: 'none',
            background: V.accentGradient,
            color: '#061421', fontSize: 13, fontWeight: 700,
            cursor: 'pointer', fontFamily: V.sans,
            boxShadow: V.shadow,
          }}
        >
          Go Home
        </button>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '10px 24px', borderRadius: 10,
            border: `1px solid ${V.border}`,
            background: 'transparent',
            color: V.sub, fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: V.sans,
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
}
